module.exports = __webpack_public_path__ + "static/media/roadster.1758c100.png";